"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentByScenario = exports.getComponent = void 0;
function getComponent(projectSettings, resourceType) {
    var _a;
    return (_a = projectSettings.components) === null || _a === void 0 ? void 0 : _a.find((r) => r.name === resourceType);
}
exports.getComponent = getComponent;
function getComponentByScenario(projectSetting, resourceType, scenario) {
    var _a;
    return scenario
        ? (_a = projectSetting.components) === null || _a === void 0 ? void 0 : _a.find((r) => r.name === resourceType && r.scenario === scenario)
        : getComponent(projectSetting, resourceType);
}
exports.getComponentByScenario = getComponentByScenario;
//# sourceMappingURL=workflow.js.map